import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Container, Row, Col, Card, CardBody, Button, Alert, FormGroup } from "reactstrap";
import * as ReactDeviceDetect from "react-device-detect";
import { toast } from "react-toastify";

import { Formik, Field } from "formik";
import * as yup from "yup";
import qs from "query-string";

import * as authRoutines from "modules/Auth/routines";
import { Preloader, FormElements } from "components";
import cookies from "services/cookies";

const TRANSLATION_BASE = "modules.auth";

export const initialValues = {
  email: "",
  password: "",
  remember: false,
  session_id: "",
  user_agent: ReactDeviceDetect.getUA,
  device_type: ReactDeviceDetect.isMobile ? "MOBILE" : ReactDeviceDetect.isTablet ? "TABLET" : "DESKTOP",
  browser: ReactDeviceDetect.browserName,
  browser_version: ReactDeviceDetect.fullBrowserVersion
};

export const validationSchema = yup.object().shape({
  email: yup.string().required(),
  password: yup.string().required().min(6)
});

const Login = ({ history, location }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [userRole, setuserRole] = useState('');

  const { isAuthenticated } = useSelector((state) => state.Auth);
  const routeParams = qs.parse(location.search);

  useEffect(() => {
    document.body.classList.add("authentication-bg");
    document.body.classList.add("authentication-bg-pattern");
    document.body.classList.add("p-0");

    return () => {
      document.body.classList.remove("authentication-bg");
      document.body.classList.remove("authentication-bg-pattern");
    };
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      if(cookies.get("session") == 3) {
        window.open("/panel", "_self");
      }
      else if(cookies.get("session") == 2) {
        window.open("/teacher", "_self");
      }
      else {
        history.push("/dashboard");
      }
    }
  }, [isAuthenticated]);

  const renderFormHeader = () => (
    <div className="text-center w-75 m-auto">
      <a href="/">
        <h3 style={{ fontSize: 22, textTransform: "uppercase", color: "black", fontWeight: "bold", margin: "auto" }}>
        Sud ekspertiza
        </h3>
      </a>
      <p className="text-muted mb-4 mt-3">{t(`${TRANSLATION_BASE}.enter_username_and_password`)}</p>
    </div>
  );

  const renderFormBottom = () => (
    <Row className="mt-3">
      <Col className="col-12 text-center">
        <p>
          <Link to="/forget-password" className="text-white-50 ml-1">
            {t(`${TRANSLATION_BASE}.forgot_password`)}?
          </Link>
        </p>
      </Col>
    </Row>
  );

  const renderFooter = () => (
    <footer className="footer footer-alt">
      2019 - 2020 &copy;{" "}
      <a href="https://napaautomative.com" target="blank" className="text-white-50">
        Napa Automative
      </a>
    </footer>
  );

  return (
    <React.Fragment>
      <div className="account-pages mt-5 mb-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Formik
                initialValues={{
                  ...initialValues,
                  email: routeParams.email
                }}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting }) => {
                  const onSuccess = () => {
                    setSubmitting(false);
                  };

                  const onError = (error) => {
                    setSubmitting(false);
                    toast.error(error?.data?.message || "Authorization failed!");
                  };

                  dispatch(authRoutines.login({ values, onSuccess, onError }));
                }}>
                {({ isSubmitting, handleSubmit }) => {
                  return (
                    <Preloader loading={isSubmitting}>
                      <Card className="bg-pattern">
                        <CardBody className="p-4 position-relative">
                          {renderFormHeader()}
                          <form onSubmit={handleSubmit}>
                            <Field
                              name="email"
                              label={t(`${TRANSLATION_BASE}.username`)}
                              placeholder={t(`${TRANSLATION_BASE}.enter_username`)}
                              checkExist={false}
                              component={FormElements.Input}
                            />
                            <Field
                              type="password"
                              name="password"
                              label={t(`${TRANSLATION_BASE}.password`)}
                              placeholder={t(`${TRANSLATION_BASE}.enter_password`)}
                              component={FormElements.Input}
                            />
                            <Button color="secondary" className="btn-block">
                              {t(`${TRANSLATION_BASE}.log_in`)}
                            </Button>
                          </form>
                        </CardBody>
                      </Card>
                    </Preloader>
                  );
                }}
              </Formik>
            </Col>
          </Row>

          {useMemo(renderFormBottom, [])}
        </Container>
      </div>

      {useMemo(renderFooter, [])}
    </React.Fragment>
  );
};

export default Login;
